var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-success btnSave",attrs:{"id":"saveCodigoBtn"}},[_c('strong',[_vm._v(_vm._s(_vm.btnTitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }